/**
 * Shared collators for display-name ordering.
 *
 * `String.prototype.localeCompare` with an options object constructs a new
 * collator on every call. Tree and asset-list sorts run tens of thousands of
 * comparisons, so the collators are created once and reused.
 */

const createCollator = (options?: Intl.CollatorOptions): Intl.Collator | null => {
    try {
        return new Intl.Collator(undefined, options);
    } catch {
        return null;
    }
};

const baseSensitivityCollator = createCollator({ sensitivity: 'base' });
const defaultCollator = createCollator();

/** Case/accent-insensitive comparison (equivalent to `{ sensitivity: 'base' }`). */
export const compareNamesInsensitive = (left: string, right: string): number =>
    baseSensitivityCollator
        ? baseSensitivityCollator.compare(left, right)
        : left.localeCompare(right, undefined, { sensitivity: 'base' });

/** Locale comparison with default sensitivity (equivalent to a bare `localeCompare`). */
export const compareNames = (left: string, right: string): number =>
    defaultCollator ? defaultCollator.compare(left, right) : left.localeCompare(right);
